import React, { useState, useContext, useEffect } from "react";
import TextArea from "../../components/TextArea";
import Section from "../../components/Section";
import styled from "styled-components";
import { useHistory } from "react-router";
import { ProfileContext } from "../../reducers/profile";
import Icons from "../../components/Icons";
import { useQuery } from "@apollo/client";
import { GET_JURIES } from "../../graphql_tags";
import Separator from "../../components/Separator";

const HomeSection = styled(Section)`
  display: flex;
  flex-direction: column;

  margin-top: 45px;

  svg {
    position: absolute;
    bottom: 0;
    z-index: 0;
  }
`;

const HomeInput = styled(TextArea)`
  display: flex;
  align-items: center;

  color: #000000;
  font-weight: normal;
`;

const UsersBtn = styled(HomeInput)`
  padding: 12.5px 20px;
  font-size: 36px;
  cursor: pointer;
`;

const UsersContainer = styled.div`
  margin-top: 20px;
  visibility: ${({ visible }) => visible};
  z-index: 1;
`;

const Users = styled(HomeInput)`
  max-height: calc(100vh - 566px);

  padding: 20px;
  width: 100%;
  scroll-behavior: smooth;
  overflow-y: scroll;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;

  p {
    cursor: pointer;
    margin: 0;
    width: 100%;

    :not(:last-child) {
      margin-bottom: 20px;
    }
  }
`;

export default () => {
  const { dispatch } = useContext(ProfileContext);
  const [visible, setVisible] = useState("hidden");
  const [data, setData] = useState({ users: [], admins: [] });
  const history = useHistory();
  const getUsers = useQuery(GET_JURIES);

  useEffect(() => {
    if (!getUsers.loading) {
      const admins = [];
      const users = [];

      getUsers.data["users"].forEach((user) => {
        if (user.is_admin) {
          admins.push(user);
        } else users.push(user);
      });

      setData({ admins, users });
    }
  }, [getUsers.loading]);

  const selectUser = (user) => {
    dispatch({
      type: "ME_GET",
      payload: { user_name: user.login, user_id: user.id },
    });

    history.push("/auth");
  };

  const handleVisible = () =>
    setVisible((state) => (state === "hidden" ? "visible" : "hidden"));

  return (
    <HomeSection>
      <UsersBtn onClick={handleVisible}>
        Выберите, пожалуйста, ФИО члена Конкурсной комиссии
      </UsersBtn>
      <UsersContainer visible={visible}>
        <Users>
          {data.users.map((user) => {
            return (
              <p key={user.id} onClick={() => selectUser(user)}>
                {user.login}
              </p>
            );
          })}
          <Separator separatorColor="#2075bc" />
          {data.admins.map((user) => {
            return (
              <p key={user.id} onClick={() => selectUser(user)}>
                {user.login}
              </p>
            );
          })}
        </Users>
      </UsersContainer>
      <Icons icon="logoBook" />
    </HomeSection>
  );
};
